import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
var IntelligentTransferComponent = (function () {
    function IntelligentTransferComponent(route, router, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        this.token = "";
        this.isShowLoadingComponent = true;
    }
    IntelligentTransferComponent.prototype.ngOnInit = function () {
        //先判断是否有token
        this.token = localStorage.getItem("transtalen-token") ? localStorage.getItem("transtalen-token") : '';
        this.checkIntelligent();
    };
    ;
    IntelligentTransferComponent.prototype.ngAfterViewInit = function () {
    };
    IntelligentTransferComponent.prototype.checkIntelligent = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            var projectId = params['projectid'];
            var courseId = params['courseId'];
            var device = params['device'];
            var exerciseIds = params['exerciseIds'];
            _this.intelligentApi(projectId, courseId).then(function (res) {
                if (res.success) {
                    var mobProjectUrl = window.location.origin + '/learning-project/' + projectId; //mob项目列表
                    var IntelligentUrl = window.location.origin + '/ai/aicoach/list/' + courseId + '?device=' + device + '&projectId=' + projectId + '&exerciseIds=' + exerciseIds + '&back_url=' + encodeURIComponent(mobProjectUrl) + '&transtalent_token=' + _this.token;
                    window.location.href = IntelligentUrl;
                }
                else if (res.data.code === 101 || res.data.code === 102) {
                    _this.router.navigate(['learning-map'], { queryParams: { code: res.data.code } });
                }
                else if (res.data.code === 103) {
                    _this.router.navigate(['learning-project', projectId]);
                }
            }).then(function () {
                _this.isShowLoadingComponent = false;
            });
        });
    };
    //智能陪练短链登录校验
    IntelligentTransferComponent.prototype.intelligentApi = function (projectId, courseId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': "ddilearner/v3/project/validateAirpLink?projectId=" + projectId + "&courseId=" + courseId,
        }).toPromise();
    };
    return IntelligentTransferComponent;
}());
export { IntelligentTransferComponent };



// WEBPACK FOOTER //
// ./src/app/intelligent-transfer/intelligent-transfer.component.ts.pre-build-optimizer.js